module.exports = {
      id: "logout-mobile-usage",
      viewBox: "0 0 20.886 28.808",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#logout-mobile",
      toString: function () {
        return this.url;
      }
    }